import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { MyUploadFile } from "../../molecules";
import { useDispatch } from "react-redux";
import { getBase64 } from "../../../utils/constansColors";
import {
  downloadHistoryDocument,
  getExcoDocument,
  listHistoryDocument,
} from "../../../config/Redux/Global/actions";
import { useParams } from "react-router-dom";
import { Gap, MyButton } from "../../atoms";
import {
  deleteDocument,
  uploadDocument,
  downloadDocument,
} from "../../../config/Redux/Global/actions";
import MyDialog from "../../molecules/Dialog";
import HelpIcon from "@mui/icons-material/Help";
import AlertMessage from "../../../components/molecules/AlertMessage";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";

const DokumenBank = ({ dataDoc, officeId: propOfficeId, isLocked, nameExco }) => {
  const dispatch = useDispatch();
  let params = useParams();
  const officeId = propOfficeId || params.officeId;
  const [openDelete, setOpenDelete] = React.useState(false);
  const [openView, setOpenView] = React.useState(false);
  const [fileNameBank, setFileNameBank] = React.useState(null);
  const [fileNameBankKampanye, setFileNameBankKampanye] = React.useState(null);

  // dialog alert
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState(null);

  // delete doc
  const [categoryDoc, setCategoryDoc] = React.useState(null);
  const [idDocument, setIdDocument] = React.useState(null);
  const [docName, setDocName] = React.useState(null);
  const [documentView, setDocumentView] = React.useState(null);

  // loading
  const [loading, setLoading] = React.useState(false);

  const handleCloseDialogDelete = () => {
    setOpenDelete(false);
  };
  const handleCloseDialogView = () => {
    setOpenView(false);
  };

  const [openHistory, setOpenHistory] = React.useState(false);
  const [dataHistoryDokumen, setDataHistoryDokumen] = React.useState(null);
  const handleCloseDialogHistory = () => {
    setOpenHistory(false);
  };

  const handleselectedFiles = async (event, param) => {
    let base64 = await getBase64(event);
    // Ungga Foto buku rekening bank* 6
    if (param === 6 || param === 15) {
      let payload = {
        id_kantor_exco: officeId,
        // id_kategori_dokumen: "6",
        id_kategori_dokumen: param,
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        if (param === 6) {
          setFileNameBank(event.name);
        } else {
          setFileNameBankKampanye(event.name);
        }

        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Buku Rekening</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
  };

  const handleOpenDelete = (categoryDoc, idDocument, docName) => {
    setCategoryDoc(categoryDoc);
    setIdDocument(idDocument);
    setDocName(docName);
    setOpenDelete(true);
  };

  const base64ToBlob = (base64, type = "application/pdf") => {
    const binStr = atob(base64.split(",")[1]);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };

  const handleDeleteFile = async (param, id) => {
    // Ungga Foto buku rekening bank* 6
    if (param === 6) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameBank(null);
        setOpenDelete(false);
      }
    }
    if (param === 15) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameBankKampanye(null);
        setOpenDelete(false);
      }
    }
  };

  // download file
  const handleDownloadDoc = async (param, id) => {
    // Ungga Foto buku rekening bank* 6
    if (param === 6 || param === 15) {
      const resp = await dispatch(downloadDocument(id));
      if (resp.type === "DOWNLOAD_SUCCESS") {
        let data = await resp.payload.dokumen;
        // console.log(data)
        let resultData = `${data}`;
        // let resultData = `data:application/pdf;base64,${data}`;
        let a = document.createElement("a");
        a.href = resultData;
        a.download = resp.payload.file_name;
        a.click();
      }
    }
  };

  // handle view file
  const handleViewDoc = async (param, id) => {
    // Ungga Foto buku rekening bank* 6
    if (param === 6 || param === 15) {
      const resp = await dispatch(downloadDocument(id));

      if (resp.type === "DOWNLOAD_SUCCESS") {
        let data = await resp.payload.dokumen;
        let resultData = `${data}`;
        const blob = base64ToBlob(resultData, "application/pdf");
        const url = URL.createObjectURL(blob);
        setOpenView(true);
        setDocumentView(url);
      }
    }
  };

  // handle history file
  const handleHistoryDokumen = async (param, id) => {
    setOpenHistory(true);
    if (param === 6 || param === 15) {
      const resp = await dispatch(listHistoryDocument(officeId, param));
      if (resp.type === "LIST_HISTORY_DOCUMENT_SUCCESS") {
        let data = await resp.payload.data;
        setDataHistoryDokumen(data);
      }
    }
  };
  const handleDownloadHistoryDokumen = async (id) => {
    const resp = await dispatch(downloadHistoryDocument(id));
    if (resp.type === "DOWNLOAD_HISTORY_DOCUMENT_SUCCESS") {
      let data = await resp.payload.dokumen;
      let a = document.createElement("a");
      a.href = data;
      a.download = resp.payload.file_name;
      a.click();
    }
  };
  const convertDate = (date) => {
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    var local = new Date(date);
    return (
      local.getDate() +
      " " +
      months[local.getMonth()] +
      " " +
      local.getFullYear()
    );
  };

  useEffect(() => {
    dataDoc &&
      dataDoc.map((item) => {
        // console.log(item)
        let fileNameBank = "";
        let fileNameBankKampanye = "";
        if (item.kategori_dokumen.id === 6) {
          fileNameBank = item.nama_dokumen;
          setFileNameBank(fileNameBank);
        }
        if (item.kategori_dokumen.id === 15) {
          fileNameBankKampanye = item.nama_dokumen;
          setFileNameBankKampanye(fileNameBankKampanye);
        }
        return null;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataDoc]);

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  //cek hak akses
  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
      return val;
    });
    return has;
  };

  const renderValueDelete = (
    <div align="center">
      <HelpIcon style={{ fontSize: 60, color: "#F06524" }} />
      <h3>Perhatian!</h3>
      <p>
        Yakin Untuk Menghapus File <br /> <b>{docName}</b> ?
      </p>
      <Gap height={20} />
      <div align="center" style={{ display: "flex", justifyContent: "center" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Batal"
          borderColor="#F06524"
          onClick={handleCloseDialogDelete}
          style={{ width: "100%" }}
        />
        <Gap width={10} />
        <MyButton
          component="span"
          color="#FFFFFF"
          backgroundColor="#F06524"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Hapus"
          borderColor="#F06524"
          style={{ width: "100%" }}
          onClick={() => handleDeleteFile(categoryDoc, idDocument)}
        />
      </div>
    </div>
  );

  const renderValueView = (
    <>
      <iframe
        title="pdfView"
        src={documentView}
        style={{ width: "100%", height: "80vh" }}
      ></iframe>
    </>
  );

  const renderHistoryFile = (
    <div align="center">
      <h3>Riwayat Perubahan Dokumen</h3>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                No.
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Aksi Peubahan
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Nama Dokumen
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Waktu Perubahan
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Oleh
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Unduh
              </th>
            </tr>
          </thead>
          <tbody>
            {dataHistoryDokumen?.map((item, key) => {
              return (
                <tr key={key} style={{ borderBottom: "#96D4D4 solid 1px" }}>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {key + 1}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.action}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    <div style={{ wordWrap: "break-word" }}>
                      {item.new_value}
                    </div>
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {convertDate(item.created_date)}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.pembuat?.nama}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.action !== "DELETE" ? (
                      <button
                        onClick={() =>
                          handleDownloadHistoryDokumen(item.id_record)
                        }
                        style={{
                          cursor: "pointer",
                          backgroundColor: "white",
                          margin: "6px",
                          padding: "6px 8px",
                          border: "2px rgb(240, 101, 36) solid",
                          color: "rgb(240, 101, 36)",
                          borderRadius: "6px",
                        }}
                      >
                        Unduh Dokumen
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Gap height={20} />
      <div align="center" style={{ display: "flex", justifyContent: "center" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Kembali"
          borderColor="#F06524"
          onClick={handleCloseDialogHistory}
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );

  return (
    <>
      <MyDialog
        openDialog={openHistory}
        handleCloseDialog={handleCloseDialogHistory}
        renderValue={renderHistoryFile}
        fullWidth={true}
        maxWidth={"medium"}
      />

      {/* delete file */}
      <MyDialog
        openDialog={openDelete}
        handleCloseDialog={handleCloseDialogDelete}
        renderValue={renderValueDelete}
        // fullWidth={true}
        // maxWidth={"medium"}
      />

      {/* view file pdf */}
      <MyDialog
        openDialog={openView}
        handleCloseDialog={handleCloseDialogView}
        renderValue={renderValueView}
        fullWidth={true}
        maxWidth={"medium"}
      />

      {/* alertMessage */}
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />

      {/* <p style={{ fontSize: 24, color: "#757575",fontWeight: 700, }}>Dokumen Bank</p> */}
      {/* <p style={{ fontSize: 22, color: "#8B8B8B" }}>Dokumen Bank</p> */}
      <Paper elevation={0} style={{ padding: 10 }}>
        <Grid container spacing={3}>
          {dataDoc?.map((item, key) => {
            return (
              <Grid item xs={12} md={6} key={key}>
                <MyUploadFile
                  hasAccess={
                    !isLocked &&
                    (checkHakAkses(
                      profile?.data?.hak_akses,
                      "Document Admin Access",
                    ) ||
                      checkHakAkses(
                        profile?.data?.hak_akses,
                        "Document Manager Access",
                      ))
                      ? true
                      : false
                  }
                  loading={loading}
                  label={<span>Unggah Scan {item?.kategori_dokumen?.nama} {(nameExco === "EXCO Provinsi" || nameExco === "EXCO Kabupaten/Kota" || nameExco === "EXCO KabKot") && item?.kategori_dokumen?.id === 6 ? <span style={{ color: "red", fontSize: "1.2em", marginLeft: "2px" }}>*</span> : ""}</span>}
                  handleselectedFile={(e) =>
                    handleselectedFiles(e, item?.kategori_dokumen?.id)
                  }
                  fileName={
                    item?.kategori_dokumen?.id === 6
                      ? fileNameBank
                      : item?.kategori_dokumen?.id === 15
                        ? fileNameBankKampanye
                        : null
                  }
                  handleDeleteFile={() => {
                    handleOpenDelete(
                      item?.kategori_dokumen?.id,
                      item?.id_dokumen,
                      item?.kategori_dokumen?.nama,
                    );
                  }}
                  handleDownloadFile={() => {
                    handleDownloadDoc(
                      item?.kategori_dokumen?.id,
                      item?.id_dokumen,
                    );
                  }}
                  handleView={() => {
                    handleViewDoc(item?.kategori_dokumen?.id, item?.id_dokumen);
                  }}
                  handleHistoryDokumen={() => {
                    handleHistoryDokumen(
                      item?.kategori_dokumen?.id,
                      item?.id_dokumen,
                    );
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    </>
  );
};

export default DokumenBank;
